import {
  SET_CATALOG_DISPLAY_TYPE,
  SET_CATALOG_SORT_BY,
  DISPLAY_TYPE_ROW,
  SORT_BY_POPULARITY,
  SET_CATALOG_TOOGLE_FILTERS_BAR,
  SET_CATALOG_FILTERS_VALUES_CHANGED,
} from './constants';
import { DISABLE_FILTERS, FORCE_REMAINS_ONLY } from '../filters/constants';

const initialState = {
  displayType: DISPLAY_TYPE_ROW,
  sortBy: SORT_BY_POPULARITY,
  filtersBarOpen: false,
  filtersValuesChanged: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DISABLE_FILTERS: {
      const { disableFilters } = action;
      return {
        ...state,
        disableFilters,
      };
    }
    case FORCE_REMAINS_ONLY: {
      const { forcedRemainsOnly } = action;
      return {
        ...state,
        forcedRemainsOnly,
      };
    }
    case SET_CATALOG_DISPLAY_TYPE: {
      const { payload } = action;
      return {
        ...state,
        displayType: payload,
      };
    }
    case SET_CATALOG_SORT_BY: {
      const { payload } = action;
      return {
        ...state,
        sortBy: payload,
      };
    }
    case SET_CATALOG_TOOGLE_FILTERS_BAR: {
      const { payload } = action;
      return {
        ...state,
        filtersBarOpen: payload,
      };
    }
    case SET_CATALOG_FILTERS_VALUES_CHANGED: {
      const { payload } = action;
      return {
        ...state,
        filtersValuesChanged: payload,
      };
    }
    default:
      return state;
  }
}
